import React, { useEffect } from "react";
import {
    FaBolt,
    FaPaintBrush,
    FaRocket,
    FaLaptopCode,
    FaGlobe,
    FaMagic
} from "react-icons/fa";
import "./FlutterFeatures.css";

const FlutterFeatures = () => {
    useEffect(() => {
        const cards = document.querySelectorAll(".ff-card");

        cards.forEach((card, i) => {
            card.style.opacity = "0";
            card.style.transform = "translateY(80px) scale(.9)";

            setTimeout(() => {
                card.style.transition =
                    "transform .8s ease, opacity .8s ease";
                card.style.opacity = "1";
                card.style.transform = "translateY(0) scale(1)";
            }, i * 140);
        });
    }, []);

    const features = [
        {
            title: "Hot Reload",
            desc: "Instant UI updates without restarting the application.",
            icon: <FaBolt />,
        },
        {
            title: "Custom Widgets",
            desc: "Beautiful widgets to build pixel-perfect interfaces.",
            icon: <FaPaintBrush />,
        },
        {
            title: "Native Performance",
            desc: "Smooth animations and ultra-fast rendering engine.",
            icon: <FaRocket />,
        },
        {
            title: "Single Codebase",
            desc: "Develop once and deploy across all platforms.",
            icon: <FaLaptopCode />,
        },
        {
            title: "Open Source",
            desc: "Powerful community-backed ecosystem by Google.",
            icon: <FaGlobe />,
        },
        {
            title: "Flexible UI",
            desc: "Create highly customizable modern app experiences.",
            icon: <FaMagic />,
        },
    ];

    return (
        <>
            <section className="ff-section">
                {/* Animated Background */}
                <div className="ff-circle ff-circle1"></div>
                <div className="ff-circle ff-circle2"></div>
                <div className="ff-grid-bg"></div>

                <div className="ff-container">
                    {/* Heading */}
                    <div className="ff-heading">
                        <div className="ff-mini-title">
                            ⚡ Powerful Flutter Features
                        </div>

                        <h2 className="ff-title">
                            Flutter{" "}
                            <span>
                                Features
                            </span>
                        </h2>

                        <p className="ff-desc">
                            Flutter provides modern tools and powerful
                            capabilities to build scalable, fast and
                            visually stunning cross-platform applications.
                        </p>
                    </div>

                    {/* Features Layout */}
                    <div className="ff-layout">
                        {features.map((item, i) => (
                            <div
                                className="ff-card"
                                key={i}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                        "translateY(-14px) rotateX(6deg)";
                                    e.currentTarget.style.boxShadow =
                                        "0 35px 70px rgba(232,33,42,0.18)";
                                    e.currentTarget.style.borderColor =
                                        "#E8212A";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                        "translateY(0px)";
                                    e.currentTarget.style.boxShadow =
                                        "0 15px 35px rgba(0,0,0,.06)";
                                    e.currentTarget.style.borderColor =
                                        "rgba(0,0,0,.05)";
                                }}
                            >
                                {/* floating glow */}
                                <div className="ff-glow"></div>

                                {/* icon */}
                                <div className="ff-icon-wrap">
                                    <div className="feature-icon">
                                        {item.icon}
                                    </div>
                                </div>

                                <h3>{item.title}</h3>

                                <p>{item.desc}</p>

                                <div className="ff-line"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default FlutterFeatures;